import { useEffect, useState } from 'react'
import { Effect } from 'effector'

type ApiResultState = {
  success: boolean
  error: { message: string; code?: number } | null
}

export function useApiResult<Params, Done, Fail>(
  effect: Effect<Params, Done, Fail>,
): ApiResultState {
  const [state, setState] = useState<ApiResultState>({
    success: false,
    error: null,
  })

  useEffect(() => {
    const unsubDone = effect.done.watch(() => {
      setState({ success: true, error: null })
    })

    const unsubFail = effect.fail.watch(({ error }) => {
      let message =
        (error as any)?.body?.message ||
        (error as any)?.message ||
        'Unknown error'
      let code = (error as any)?.status
      setState({ success: false, error: { message, code } })
    })

    return () => {
      unsubDone()
      unsubFail()
    }
  }, [effect])

  return state
}
